import * as React from "react";
const SVGComponent = ({ width = "26px", height = "26px", color = "#000", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    cursor="pointer"
    {...props}
  >
    <rect
      x={5.65674}
      y={18.6567}
      width={18}
      height={2}
      rx={1}
      transform="rotate(-45 5.65674 18.6567)"
      fill={color}
    />
    <rect
      x={18.3848}
      y={20.071}
      width={18}
      height={2}
      rx={1}
      transform="rotate(-135 18.3848 20.071)"
      fill={color}
    />
  </svg>
);
export default SVGComponent;